import { render, staticRenderFns } from "./EditMultiselect.vue?vue&type=template&id=3bf0378b&scoped=true&"
import script from "./EditMultiselect.vue?vue&type=script&lang=js&"
export * from "./EditMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./EditMultiselect.vue?vue&type=style&index=0&id=3bf0378b&scoped=true&lang=css&"
import style1 from "./EditMultiselect.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf0378b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bf0378b')) {
      api.createRecord('3bf0378b', component.options)
    } else {
      api.reload('3bf0378b', component.options)
    }
    module.hot.accept("./EditMultiselect.vue?vue&type=template&id=3bf0378b&scoped=true&", function () {
      api.rerender('3bf0378b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EditMultiselect.vue"
export default component.exports